import { FieldArray } from "formik";
import React from "react";
import AddExternalLinks from "./AddExternalLinks";

const CTAForm = ({ showErrors = false }) => {
  return (
    <FieldArray
      name="business_box_cta"
      render={(props) => {
        return (
          <AddExternalLinks
            {...props}
            showError={showErrors}
            name="business_box_cta"
            addMore={props.form.values.business_box_cta.length < 2}
          />
        );
      }}
    />
  );
};

export default CTAForm;
